(function () {
    'use strict';

    angular
        .module('procedureModule')
        .controller('ProcedureMetadataReviewController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        $scope.setMetadataBlock = function (metadataBlock) {
            $scope.procedure = _.cloneDeep($scope.procedure);
            $scope.procedure.MetadataBlock = metadataBlock;
        };
    }
})();